//1 = light blue, 2 = blue, 3 = yellow, 4 = red

export const axe = [
    0, 0, 0, 0, 0, 0, 3, 3, 3, 5, 5, 0, 
    0, 0, 0, 0, 0, 0, 3, 2, 2, 2, 5, 5, 
    0, 0, 0, 0, 0, 0, 3, 2, 1, 1, 2, 5, 
    0, 0, 0, 0, 0, 0, 5, 2, 1, 1, 2, 3, 
    0, 0, 0, 0, 0, 0, 0, 2, 2, 2, 2, 3, 
    0, 0, 0, 0, 0, 0, 2, 0, 5, 3, 3, 3, 
    0, 0, 0, 0, 0, 4, 0, 0, 0, 0, 0, 0, 
    0, 0, 0, 0, 4, 0, 0, 0, 0, 0, 0, 0, 
    0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 
    0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 
    4, 4, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 
    4, 4, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
]